const STORAGE_KEY = 'topPageMode';
const MODE_COOKIE_NAME = 'topPageMode';
export const TOP_PAGE_MODE = {
  LEGACY: 'legacy',
  IMPROVED: 'improved'
};

const safeLocalStorage = () => {
  try {
    return window.localStorage;
  } catch (_error) {
    return null;
  }
};

const getModeFromCookie = () => {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie.match(new RegExp(`(?:^|; )${MODE_COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const setModeCookie = (mode) => {
  if (typeof document === 'undefined') {
    return;
  }
  if (!mode) {
    document.cookie = `${MODE_COOKIE_NAME}=; path=/; max-age=0`;
    return;
  }
  const maxAge = 60 * 60 * 24 * 365; // roughly one year
  document.cookie = `${MODE_COOKIE_NAME}=${encodeURIComponent(mode)}; path=/; max-age=${maxAge}`;
};

export const getTopPageMode = () => {
  // cookieを参照先として優先する。
  // cookieはサーバー（ログイン時にロール別デフォルト値を書き込む）とJS（トグル切り替え時に更新する）
  // の両方が読み書きする唯一の共有ストアとして機能している。
  // これにより「ログイン直後はデフォルトUI」「遷移をまたいでも切り替え済みのUIを維持」が両立する。
  // localStorageはcookieが存在しない環境向けのフォールバックとしてのみ参照する。
  const cookieMode = getModeFromCookie();
  if (cookieMode) {
    return cookieMode;
  }
  const storage = safeLocalStorage();
  return storage ? storage.getItem(STORAGE_KEY) : null;
};

export const setTopPageMode = (mode) => {
  const storage = safeLocalStorage();
  if (!storage) {
    setModeCookie(mode);
    return;
  }
  if (!mode) {
    storage.removeItem(STORAGE_KEY);
    setModeCookie(null);
    return;
  }
  storage.setItem(STORAGE_KEY, mode);
  setModeCookie(mode);
};

const applyModeToElement = (element, mode) => {
  if (!element) {
    return;
  }
  element.classList.toggle('top-page-improved', mode === TOP_PAGE_MODE.IMPROVED);
};

export const applyModeToBody = (mode) => {
  if (typeof document === 'undefined') {
    return;
  }
  applyModeToElement(document.body, mode);
};

const getStoredOrLegacyMode = () =>
  getTopPageMode() === TOP_PAGE_MODE.IMPROVED ? TOP_PAGE_MODE.IMPROVED : TOP_PAGE_MODE.LEGACY;

export const syncBodyWithStoredMode = () => {
  if (typeof document === 'undefined') {
    return;
  }
  applyModeToElement(document.body, getStoredOrLegacyMode());
};

export const registerTopPageModeBootstrap = () => {
  const apply = () => syncBodyWithStoredMode();
  document.addEventListener('turbolinks:load', apply);
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('turbolinks:before-render', (event) => {
    const newBody = event && event.data && event.data.newBody;
    if (!newBody) {
      return;
    }
    applyModeToElement(newBody, getStoredOrLegacyMode());
  });
  apply();
};
